import styled from 'styled-components';

export const Container = styled.div`
    background: white;
    padding-top: 10px;
    padding-bottom: 10px;
    border-radius: 5px;
    height: auto;
    width: 85px;
    display: flex;
    flex-direction: column;
    z-index: 100;
    border-style: solid;
    border-width: 1px;
    border-color: ${props => props.theme.borderColor};
    -webkit-box-shadow: 1px 1px 15px 1px rgb(207, 211, 228);
    -moz-box-shadow: 1px 1px 15px 1px rgb(207, 211, 228);
    box-shadow: 1px 1px 15px 1px rgb(207, 211, 228);
    text-align:center;
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-gap: 10px;
    justify-items: center;
    > * {
        border-width: 0px;
        color: #85859e;
    }
}
`;
